import { UsersOptions } from 'system/constants';
import { IRank, ISystemUser } from 'system/types';

const SETTING_NAME_ALLOW_QUOTE_RELEASE_WITHOUT_SENDING_EMAIL =
  'allow_quote_release_without_sending_email';

export const mapBlockUnblockDataToSend = (users: ISystemUser[], option: UsersOptions) => ({
  users: users.map((user: ISystemUser) => ({
    id: user.userId,
    blocked: option === UsersOptions.BLOCK ? 1 : 0,
  })),
});

export const mapBlockUnblockIpDataToSend = (users: ISystemUser[]) => ({
  user_ids: users.map((user: ISystemUser) => user.userId),
});

export const mapUserChangeAssignedCompanyDataToSend = (
  users: ISystemUser[],
  assignedCompanyId: number | null
) => ({
  users: users.map((user: ISystemUser) => ({
    id: user.userId,
    assigned_company_id: assignedCompanyId || '',
  })),
});

export const mapUserRanksDataToSend = (users: ISystemUser[], ranks: number[]) => {
  const user_has_ranks: Array<{ user_id: string; rank_id: number }> = [];
  users?.map((user: ISystemUser) => {
    ranks?.map((rank: number) => {
      user_has_ranks.push({
        user_id: user.userId,
        rank_id: rank,
      });
    });
  });

  return { user_has_ranks };
};

export const mapUserSettingDataToSend = (userId: number, checked: boolean) => ({
  user_setting: {
    user_id: userId,
    name: 'allow_quote_release_without_sending_email',
    value: checked ? 1 : 0,
  },
});

export const mapUserSettingsDataToSend = (
  users: ISystemUser[],
  allowQuoteReleaseWithoutSendingEmail: boolean
) => ({
  user_settings: users.map((user: ISystemUser) => ({
    user_id: user.userId,
    name: SETTING_NAME_ALLOW_QUOTE_RELEASE_WITHOUT_SENDING_EMAIL,
    value: allowQuoteReleaseWithoutSendingEmail ? 1 : 0,
  })),
});

export const mapUserRankResourceDataToSend = (
  rankId: number,
  resourceUrl: string,
  checked: boolean
) => ({
  user_rank_resource: {
    rank_id: rankId,
    resource: resourceUrl,
    value: checked ? 1 : 0,
  },
});

export const mapRankDataToSend = (rank: IRank) => {
  const userRank: { name: string; id?: string } = {
    name: rank.rankName,
  };

  if (rank.rankId) {
    userRank['id'] = rank.rankId;
  }

  return { user_rank: userRank };
};

export const mapRemoveRankDataToSend = (rank: IRank) => ({
  user_ranks: [rank.rankId],
});
